module.exports = __webpack_public_path__ + "img/friend6.7511e47c.png";